import styled from 'styled-components';

export const Card = styled.div<{ $over?: boolean }>`
	background: ${p => p.theme.white};
	border: 1px solid ${p => (p.$over ? '#FECACA' : p.theme.border)};
	border-radius: 10px;
	padding: 16px 20px;
	margin-bottom: 16px;
	transition: border-color 0.25s;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 14px;
	flex-wrap: wrap;
	gap: 8px;
`;

export const Title = styled.div<{ $over?: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	color: ${p => (p.$over ? p.theme.danger : p.theme.primary)};
	font-weight: 600;

	svg {
		flex-shrink: 0;
	}
`;

export const Metrics = styled.div`
	display: flex;
	border-top: 1px solid ${p => p.theme.border};
	padding-top: 12px;
	flex-wrap: wrap;
`;

export const Metric = styled.div`
	flex: 1;
	min-width: 120px;
	display: flex;
	flex-direction: column;
	gap: 2px;
	padding-right: 16px;

	& + & {
		padding-left: 16px;
		border-left: 1px solid ${p => p.theme.border};
	}
`;

export const MetricLabel = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const Dot = styled.span<{ $color: string }>`
	width: 8px;
	height: 8px;
	border-radius: 2px;
	background: ${p => p.$color};
	flex-shrink: 0;
`;

export const Warn = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 12px;
	background: ${p => p.theme.dangerBg};
	border: 1px solid ${p => p.theme.danger};
	border-radius: 7px;
	padding: 9px 14px;

	svg {
		flex-shrink: 0;
	}
`;
